import { useId, useState } from 'react'
import { Input } from '@platform/ui'
import { Eye, EyeOff } from 'lucide-react'

/**
 * Input para respuestas de preguntas de seguridad: SIEMPRE enmascarado por defecto
 * (como una contraseña) para que la respuesta no se filtre en pantalla. El ojito
 * permite revelarla momentáneamente. `autoComplete/spellCheck` off para que el
 * navegador no la guarde ni la sugiera. En el backend la respuesta viaja y se
 * almacena solo como hash argon2 (nunca en claro).
 */
export function MaskedInput({
  value,
  onChange,
  placeholder,
  id,
  required,
  ariaLabel,
}: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  id?: string
  required?: boolean
  ariaLabel?: string
}) {
  const [show, setShow] = useState(false)
  const autoId = useId()
  const inputId = id ?? autoId
  return (
    <div className="relative">
      <Input
        id={inputId}
        type={show ? 'text' : 'password'}
        required={required}
        value={value}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className="pr-10"
        onChange={(e) => onChange(e.target.value)}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Ocultar respuesta' : 'Mostrar respuesta'}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground hover:text-foreground"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  )
}
